// extracted by mini-css-extract-plugin
module.exports = {"skeletonLoaderWrapper":"wH7SmRZj"};